import { useMemo } from "react";
import MarkdownIt from "markdown-it";
import texmath from "markdown-it-texmath";
import katex from "katex";
import DOMPurify from "dompurify";
import "./markdown.css";

export function safeMarkdownLink(url: string): boolean {
  return /^(https?:\/\/|mailto:)/i.test(url) && !/\s/.test(url) &&
    Array.from(url).every(character => character.charCodeAt(0) >= 32);
}
export function safeMarkdownImage(url: string): boolean {
  return /^\/media\/task-images\/[a-f\d-]+\.webp$/.test(url);
}

const markdown = new MarkdownIt({ html: false, breaks: true }).use(texmath, {
  engine: katex,
  delimiters: ["dollars", "brackets"],
  katexOptions: {
    trust: false,
    throwOnError: false,
    maxExpand: 1000,
    maxSize: 20,
  },
});
markdown.validateLink = (url) =>
  safeMarkdownLink(url) || safeMarkdownImage(url);
const imageRule = markdown.renderer.rules.image!;
markdown.renderer.rules.image = (tokens, index, options, env, renderer) => {
  const token = tokens[index];
  if (!safeMarkdownImage(String(token.attrGet("src") || ""))) {
    return markdown.utils.escapeHtml(token.content || "Изображение недоступно");
  }
  token.attrSet("loading", "lazy");
  return imageRule(tokens, index, options, env, renderer);
};

export function renderMarkdown(source: string): string {
  // HTML is disabled at parse time; sanitize again after rendering math.
  return DOMPurify.sanitize(markdown.render(source), {
    USE_PROFILES: { html: true, mathMl: true, svg: true },
    ADD_TAGS: ["eq", "eqn"],
    FORBID_TAGS: ["style", "iframe", "form", "input"],
  });
}

export function MarkdownPreview({
  value,
  label,
}: {
  value: string;
  label?: string;
}) {
  const html = useMemo(() => renderMarkdown(value), [value]);
  return (
    <div
      className="markdown-content"
      aria-label={label}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
